<footer class="usa-footer usa-footer--big">
  <div class="usa-footer__primary-section">
    <nav class="usa-footer__nav usa-footer__nav--primary" aria-label="Footer navigation">
      <plants-primary-nav></plants-primary-nav>
    </nav>
  </div>
  <div class="usa-footer__primary-section usa-footer__links-section">
    <div class="grid-container">
      <div class="grid-row grid-gap">
        <div class="tablet:grid-col-4">
          <nav class="usa-footer__nav" aria-label="Footer secondary navigation left">
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://ask.usda.gov"
                  target="_blank"
                  rel="noopener noreferrer"
                  >AskUSDA</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Privacy Policy</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/accessibility-statement"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Accessibility Statement</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/non-discrimination-statement"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Non-Discrimination Statement</a
                >
              </li>
            </ul>
          </nav>
        </div>
        <div class="tablet:grid-col-4">
          <nav class="usa-footer__nav" aria-label="Footer secondary navigation center">
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >USDA.gov</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usa.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >USA.gov</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/ocio/guidelines-and-compliance-resources/information-quality-activities"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Information Quality</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/plain-writing"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Plain Writing</a
                >
              </li>
            </ul>
          </nav>
        </div>
        <div class="tablet:grid-col-4">
          <nav class="usa-footer__nav" aria-label="Footer secondary navigation right">
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.whitehouse.gov"
                  target="_blank"
                  rel="noopener noreferrer"
                  >WhiteHouse.gov</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a
                  class="usa-link--external"
                  href="https://www.usda.gov/ogc/office-information-affairs/foia-division"
                  target="_blank"
                  rel="noopener noreferrer"
                  >FOIA</a
                >
              </li>
              <li class="usa-footer__secondary-link">
                <a [routerLink]="['/status']">Current Status</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div class="usa-footer__secondary-section">
    <div class="usa-footer__logo margin-left-4">
      <plants-branding></plants-branding>
    </div>
  </div>
</footer>
